import React, { useEffect, useState } from "react";
import "../../styles/app/CountrySelectorBar.css";
import { countryService } from "../../services/country.service";

interface CountryItem {
    name: string;
    code: string;
}

const CountrySelectorBar: React.FC = () => {
    const [countryList, setCountryList] = useState<CountryItem[]>([]);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const { receivers } = await countryService.getCountryLists();
                if (receivers) {
                    const formatted = receivers.map((c) => ({
                        name: c.name,
                        code: (c.iso2Country || "").toLowerCase(),
                    }));
                    setCountryList(formatted);
                }
            } catch (error) {
                console.error("Error loading country list in CountrySelectorBar:", error);
            }
        };
        fetchCountries();
    }, []);

    // Triple for true infinite loop marquee
    const displayCountries = [...countryList, ...countryList, ...countryList];

    return (
        <div className="country-selector-bar">
            <div className="country-selector-container">
                <div className="countries-track">
                    {displayCountries.map((country, index) => (
                        <button key={index} className="country-btn">
                            <img
                                src={`https://flagcdn.com/w40/${country.code}.png`}
                                srcSet={`https://flagcdn.com/w80/${country.code}.png 2x`}
                                width="24"
                                height="16"
                                alt={`${country.name} - ${country.name}`}
                                className="country-flag-img"
                                loading="lazy"
                                decoding="async"
                            />
                            <span className="country-name">{country.name}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CountrySelectorBar;
